import { colorCSS } from "../../styles";
import { useAnalytics } from "../hooks";

import { EmailIcon } from "./icons";
import { GenericShareButton, InnerShareButton } from "./social-sharing.styles";

export type EmailShareButtonProps = {
    readonly block?: boolean;
    readonly buttonColor?: string;
    readonly buttonText?: string;
    readonly buttonTextColor?: string;
    readonly iconColor?: string;
    readonly message: string;
    readonly shareUrl: string;
    readonly uuid: string;
    readonly type: string;
};

export const EmailShareButton = ({
    block = false,
    buttonColor = colorCSS("N300"),
    buttonText = "Email",
    buttonTextColor = "white",
    iconColor = "white",
    message,
    shareUrl,
    uuid,
    type
}: EmailShareButtonProps) => {
    const { sendTrackEvent } = useAnalytics();
    const url = encodeURI(
        `mailto:?subject=Trello&body=${message}\n\n${shareUrl}`
    );

    return (
        <GenericShareButton
            $block={block}
            $buttonColor={buttonColor}
            $colorOverride={buttonTextColor}
            href={url}
            title={buttonText}
            onClick={() =>
                sendTrackEvent("clickedAnchor", {
                    event: "clicked",
                    eventComponent: "button",
                    eventContainer: type,
                    label: buttonText,
                    labelEnglish: "Email",
                    uuid: `${uuid}_emailButton`,
                    href: url
                })
            }
            data-uuid={`${uuid}_emailButton`}
        >
            <InnerShareButton>
                <EmailIcon color={iconColor} />
                <span>{buttonText}</span>
            </InnerShareButton>
        </GenericShareButton>
    );
};
